/*
 * @Author: Latte
 * @Date: 2021-05-27 16:34:31
 * @LAstEditors: Latte
 * @LastEditTime: 2021-07-22 12:02:08
 * @Description: 
 * @FilePath: \Siui.Cloud.Medical.Web\src\api\ultrasonicGroupsDetail.js
 */

import request from '@/utils/request'
import config from '@/utils/config'

/**
 * 获取超人圈群组详情
 *
 * @param {*} params
 */
export function getOne(params) {
    return request({
        url: config.API_ADMIN + '/Api/V1/AdminForums/ForumGroup/One',
        method: 'get',
        params
    })
}

/**
 * 更新超人圈群组详情
 *
 * @param {*} data
 */
export function updateForumGroups(data) {
    return request({
        url: config.API_ADMIN + '/Api/V1/AdminForums/ForumGroup/Update',
        method: 'post',
        data
    })
}

/**
 * 后台分页获取超人圈群组资料集合
 * @param parm
 * @returns {*}
 */
export function getForumGroupFileList(params) {
    return request({
        url: config.API_ADMIN + '/Api/V1/AdminForums/ForumGroupFile/List',
        method: 'get',
        params
    })
}

/**
 * 后台超人圈群组文件资料删除或恢复
 *
 * @param {*} data
 */
export function forumGroupFileDeleteOrBack(data) {
    return request({
        url: config.API_ADMIN + '/Api/V1/AdminForums/ForunGroupFile/DeleteOrBack',
        method: 'delete',
        params: data
    })
}
